import { getUserLocale } from '@klarna-web-sdk/utils/src/getUserLocale';
import { Language } from './types';
const isSupportedLanguage = (lng) => Object.values(Language).includes(lng);
const extractLanguageFromLocale = (locale) => locale.substring(0, 2)?.toLowerCase();
export const getLanguage = () => {
    const browserLocale = window.navigator.language;
    const locale = getUserLocale();
    if (locale) {
        const language = extractLanguageFromLocale(locale);
        if (isSupportedLanguage(language))
            return language;
    }
    if (browserLocale) {
        const language = extractLanguageFromLocale(browserLocale);
        if (isSupportedLanguage(language))
            return language;
    }
    return Language.EN;
};
